'use strict';
{
    angular.module('tf.portfolio.newBusiness', [])

        .factory('newBusiness', ['$localStorage', '$http', function ($localStorage, $http) {
            var storage = $localStorage.$default({});
            return function (portfolioId) {
                var storageKey = 'newBusiness_' + portfolioId;
                return {
                    newBusiness : function newBusiness() {
                        var now = new Date();
                        var newBusiness =  storage[storageKey] || {asAt : '' + now, trades : []};

                        var asAt = new Date(newBusiness.asAt);

                        // New business is old, so delete it
                        if (asAt.getFullYear() != now.getFullYear() || asAt.getMonth() != now.getMonth() || asAt.getDay() != now.getDay()) {
                            newBusiness =  {asAt : '' + now, trades : []};
                        }
                        storage[storageKey] = newBusiness;
                        return newBusiness.trades;
                    },
                    addNewBusiness : function addNewBusiness(trades) {
                        return $http.put('/tradefloor/api/portfolio/' + portfolioId + '/newbusiness', trades);
                    },
                    removeNewBusiness : function addNewBusiness(trade) {
                        return $http.delete('/tradefloor/api/portfolio/' + portfolioId + '/newbusiness/' + trade.id);
                    }
                }
            }
        }])

        .controller('NewBusinessCtrl', ['$scope', '$uibModalInstance', 'trades', 'newBusiness', function ($scope, $uibModalInstance, trades, newBusiness) {

            $scope.trades = trades;
            $scope.processing = false;
            $scope.ok = function () {
                $scope.processing = true;
                var newBusinessTrade = [];
                for (var i = 0; i < $scope.trades.length; i++) {
                    var newBusinessToAddTrade = {
                        c : $scope.trades[i].code,
                        q : $scope.trades[i].quantity,
                        t : $scope.trades[i].tradeDate,
                        p : $scope.trades[i].price,
                        i : $scope.trades[i].include,
                        m : $scope.trades[i].manual
                    };
                    newBusinessTrade.push(newBusinessToAddTrade);
                }
                newBusiness.addNewBusiness(newBusinessTrade).then(function(response) {
                    var newBusinessTrades = response.data;
                    $uibModalInstance.close(newBusinessTrades.map(function (t) {
                        return {
                            code : t.c,
                            quantity : t.q
                        };
                    }));
                });
            };

            $scope.removeTrade = function(trade) {
                $scope.trades = $scope.trades.filter(function (t) {
                    return t != trade;
                })
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }]);
}
